/* eslint-disable no-param-reassign */
export default {
    /**
     * Updates a form
     * @param {Object} state Store state
     * @param {Object} payload Payload of the action
     * @param {String} payload.id Form identifier
     * @param {Object} payload.properties Form data
     */
    UPDATE_FORM(state, { id, properties }) {
        state.forms = state.forms.map(form => {
            if (form.id === id) {
                form.properties = properties;
            }
            return form;
        });
    },

    /**
     * Inserts a form
     * @param {Object} state Store state
     * @param {Object} payload Payload of the action
     * @param {String} payload.id Form identifier
     * @param {Object} payload.properties Form data
     */
    INSERT_FORM(state, { id, properties }) {
        state.forms.push({ id, properties });
    },

    /**
     * Deletes a form
     * @param {Object} state Store state
     * @param {String} id Form identifier
     */
    DELETE_FORM(state, id) {
        state.forms = state.forms.filter(form => form.id !== id);
    },

    /**
     * Delete route forms
     * @param {Object} state Store state
     * @param {String} route Route name
     */
    DELETE_ROUTE_FORMS(state, route) {
        const formInRouteRegex = new RegExp(`^${route}__[a-zA-Z]+`);
        state.forms = state.forms.filter(form => !form.id.match(formInRouteRegex));
    },

    /**
     * Deletes a form
     * @param {Object} state Store state
     */
    DELETE_ALL_FORMS(state) {
        state.forms = [];
    }
};
